import { render, staticRenderFns } from "./collBar.vue?vue&type=template&id=f71e972a&scoped=true"
import script from "./collBar.vue?vue&type=script&lang=js"
export * from "./collBar.vue?vue&type=script&lang=js"
import style0 from "./collBar.vue?vue&type=style&index=0&id=f71e972a&prod&lang=scss&scoped=true"
import style1 from "@/styles/pc.css?vue&type=style&index=1&id=f71e972a&prod&scoped=true&lang=css&external"
import style2 from "./collBar.vue?vue&type=style&index=2&id=f71e972a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71e972a",
  null
  
)

export default component.exports